import React, { useEffect, useState } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import inscriptionStyle from './InscriptionReportPage.module.css'
import BackBar from '../../components/BackBar/BackBar';
import { LuPrinter } from "react-icons/lu";
import { IoShareSocialOutline } from "react-icons/io5";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
export default function InscriptionReportPage() {

  const navigate = useNavigate();
  const { author_id } = useParams();
  const query = new URLSearchParams(useLocation().search);
  const event_id = query.get("event_id");
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/getInscriptionReport.php?author_id=${author_id}&event_id=${event_id}`)
      .then(res => res.json())
      .then(data => setTableData(data.data));
  }, []);

  const handleClick = () => {
    navigate('/EventManagementDetailsPage'); // Navigate to the Author Tracking Page
  };

  // console.log("tableData", tableData);

  return (
    <>
      <AdminHeader />
      <div className={inscriptionStyle.inscriptionreportpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={inscriptionStyle.inscriptionreportBody}>
                <div className={`${inscriptionStyle.incriptionButtons} d-flex flex-wrap align-items-center`}>
                  {/*<button onClick={handleClick} className={`${inscriptionStyle.incriptionBackbtn} btn btn-primary me-auto`}>Back</button> */}
                  <div>
                    <Link to={`/inscriptionReportDetailPage/${author_id}/${event_id}`}>
                      <button className={`${inscriptionStyle.incriptionSharebtn} btn btn-secondary me-3`}>
                        <IoShareSocialOutline className={`${inscriptionStyle.incriptionIcons} me-2`} />Share
                      </button>
                    </Link>
                    <Link to={`/inscriptionReportDetailPage/${author_id}/${event_id}`}>
                      <button className={`${inscriptionStyle.incriptionPrintbtn} btn btn-secondary`}>
                        <LuPrinter className={`${inscriptionStyle.incriptionIcons} me-2`} />Print
                      </button>
                    </Link>
                  </div>
                </div>
                <div className={`${inscriptionStyle.incriptionTitles} d-flex flex-wrap align-items-center`}>
                  <h4 className="me-auto">Inscription Report</h4>
                  <h4>Author: {tableData[0]?.first_name} {tableData[0]?.last_name}</h4>
                </div>
                <div className="table-responsive">
                  <table className={`${inscriptionStyle.incriptionTables} table table-striped table-bordered`} style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th>ISBN</th>
                        <th>Book Title</th>
                        <th>Inscription Name</th>
                        <th>Recipient’s Name</th>
                        <th>Homeroom Teacher</th>
                        <th>Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row, i) => (
                        <tr key={i}>
                          <td>{row.isbn}</td>
                          <td class="text-start">{row.title}</td>
                          <td>{row.inscription_name}</td>
                          <td>{row.inscription_st_full_name}</td>
                          <td>{row.inscription_teacher_name}</td>
                          <td>{row.inscription_grade_level}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
